export class CardSvg {
  public svg_html: string;
  public static photo_selector = '.photo';
  public static v1_price_text_selector = '.v1_price_text';
  public static v2_price_text_selector = '.v2_price_text';
  public static type_selector = '.type';
  public static brand_selector = '.brand';
  public static usps_selector = '.usps';
  public static wallet_opener_type_1_selector = '.usp_0';
  public static wallet_opener_type_2_selector = '.usp_1';
  public hasPhoto = false;
  public hasBrand = false;
  public hasType = false;
  public hasV1PriceText = false;
  public hasUSPS = false;
  public numberOfUSPS = 0;
  public hasV2PriceText = false;

  constructor(svg_html: string) {
    this.svg_html = svg_html;
    let container = document.createElement('div');
    this.hasPhoto = (this.getValueIfItExists(CardSvg.photo_selector) !== undefined);
    this.hasV1PriceText = (this.getValueIfItExists(CardSvg.v1_price_text_selector) !== undefined);
    this.hasV2PriceText = (this.getValueIfItExists(CardSvg.v2_price_text_selector) !== undefined);
    this.hasUSPS = (this.getValueIfItExists(CardSvg.usps_selector) !== undefined);
    this.hasBrand = (this.getValueIfItExists(CardSvg.brand_selector) !== undefined);
    this.hasType = (this.getValueIfItExists(CardSvg.type_selector) !== undefined);
    container.innerHTML = svg_html;
    if (this.hasUSPS) {
      this.numberOfUSPS = this.getValueIfItExists(CardSvg.usps_selector, true).children.length;
    }
  }

  extractFormValues(isCardAWalletOpener = false):{} {
    let formData:any = {};
    if (this.getValueIfItExists(CardSvg.brand_selector)) {
      formData[CardSvg.brand_selector] = this.getValueIfItExists(CardSvg.brand_selector)
    }
    if (this.getValueIfItExists(CardSvg.type_selector)) {
      formData[CardSvg.type_selector] = this.getValueIfItExists(CardSvg.type_selector)
    }
    // If we have a wallet opener, also add the additional lines
    if (isCardAWalletOpener) {
      if (this.getValueIfItExists(CardSvg.wallet_opener_type_1_selector)) {
        formData[CardSvg.wallet_opener_type_1_selector] = this.getValueIfItExists(CardSvg.wallet_opener_type_1_selector)
      }
      if (this.getValueIfItExists(CardSvg.wallet_opener_type_2_selector)) {
        formData[CardSvg.wallet_opener_type_2_selector] = this.getValueIfItExists(CardSvg.wallet_opener_type_2_selector)
      }
    }
    return formData;
  }

  getValueIfItExists(selector:string, sendElement:boolean = false): any|undefined {
    let output = undefined;
    let element = document.createElement('div');
    element.innerHTML = this.svg_html;

    let value = element.querySelector(selector);
    if (value) {
      if (selector !== CardSvg.photo_selector) {
        output = value.textContent;
      } else {
        output = value;
      }
    }
    if (sendElement) { return value }
    return output;
  }

  setValue(selector: string, value_string): boolean {
    const element = document.createElement('div');
    element.innerHTML = this.svg_html;
    let el = element.querySelector(selector);
    if (!el) {
      return false;
    }
    if (selector == CardSvg.photo_selector) {
      el.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', value_string);
    } else {
      el.innerHTML = value_string;
    }
    this.svg_html = element.innerHTML;
    return true;
  }

}



// WEBPACK FOOTER //
// /app/src/app/_models/card-svg.ts